// client/src/components/configuracoes/entrega/EntregaForm.js
import React from 'react';
import { MapPin, XCircle } from 'lucide-react';
import { FormStepper, FormStepNavigation } from '../../shared/FormStepper';
import SecaoRetirada from './SecaoRetirada';
import SecaoEntrega from './SecaoEntrega';
import SecaoTeste from './SecaoTeste';

// ============================================================
// FORMULÁRIO COMPLETO
// ============================================================
export const EntregaForm = ({
    current, formData, setFormData, opcoesUnidade,
    currentStep, setCurrentStep,
    setRetirada, setEntrega, atualizarDia,
    adicionarFaixaRaio, atualizarFaixaRaio, removerFaixaRaio,
    adicionarFaixaCep, atualizarFaixaCep, removerFaixaCep,
    isSaving, onSubmit, onCancel,
    testeForm, setTesteForm, testeResultado, testando, onTestar,
}) => {
    const STEP_LABELS = current ? ['Retirada', 'Entrega', 'Testar Cálculo'] : ['Retirada', 'Entrega'];

    return (
    <form onSubmit={onSubmit}>
        {/* Seletor de unidade (apenas na criação) */}
        {!current && (
            <div className="form-section">
                <h4 className="form-section-title">
                    <MapPin size={15} style={{ marginRight: 4, verticalAlign: 'middle' }} />
                    Unidade
                </h4>
                <div className="form-grid-container-cols-2">
                    <div className="form-group">
                        <label className="form-label">Aplicar para</label>
                        <select
                            className="form-input"
                            value={formData.unidade}
                            onChange={e => setFormData(prev => ({ ...prev, unidade: e.target.value }))}
                        >
                            <option value="">Configuração padrão da conta</option>
                            {opcoesUnidade.map(u => (
                                <option key={u.uid} value={u.uid}>{u.label}</option>
                            ))}
                        </select>
                        <small style={{ color: '#64748b', fontSize: '0.8rem' }}>
                            "Padrão da conta" aplica-se quando a unidade não tem config própria
                        </small>
                    </div>
                </div>
            </div>
        )}

        <FormStepper currentStep={currentStep} steps={STEP_LABELS} />

        {/* ── ETAPA RETIRADA ── */}
        {currentStep === 1 && (
            <SecaoRetirada
                retirada={formData.retirada}
                setRetirada={setRetirada}
                atualizarDia={atualizarDia}
            />
        )}

        {/* ── ETAPA ENTREGA ── */}
        {currentStep === 2 && (
            <SecaoEntrega
                entrega={formData.entrega}
                setEntrega={setEntrega}
                adicionarFaixaRaio={adicionarFaixaRaio}
                atualizarFaixaRaio={atualizarFaixaRaio}
                removerFaixaRaio={removerFaixaRaio}
                adicionarFaixaCep={adicionarFaixaCep}
                atualizarFaixaCep={atualizarFaixaCep}
                removerFaixaCep={removerFaixaCep}
            />
        )}

        {/* ── ETAPA TESTE ── */}
        {currentStep === 3 && current && (
            <SecaoTeste
                testeForm={testeForm}
                setTesteForm={setTesteForm}
                testeResultado={testeResultado}
                testando={testando}
                onTestar={onTestar}
            />
        )}

        {/* ── FORM ACTIONS ── */}
        <div className="form-actions">
            <button type="button" onClick={onCancel} className="action-button action-button-secondary" disabled={isSaving}>
                <XCircle size={18} className="icon" /> Cancelar
            </button>
            <FormStepNavigation
                currentStep={currentStep}
                totalSteps={STEP_LABELS.length}
                onBack={() => setCurrentStep(s => s - 1)}
                onNext={() => setCurrentStep(s => s + 1)}
                isSubmitting={isSaving}
                submitLabel={current ? 'Salvar Alterações' : 'Criar Configuração'}
            />
        </div>
    </form>
    );
};

export default EntregaForm;
